import { render, staticRenderFns } from "./Cube.vue?vue&type=template&id=a5abb14a&scoped=true&"
import script from "./Cube.vue?vue&type=script&lang=js&"
export * from "./Cube.vue?vue&type=script&lang=js&"
import style0 from "./Cube.vue?vue&type=style&index=0&id=a5abb14a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5abb14a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
